import anime from 'animejs/lib/anime.es.js';

// buttonBlock
const buttonBlockAnimation = {
	setupAnimation: function (parentBlock) {
		const buttonBlockWrap = parentBlock.querySelector(".button-block__wrap");
		anime.set(buttonBlockWrap, {
			opacity: 0
		});
		
	},
	playAnimation: function(parentBlock) {
			
		const buttons = parentBlock.querySelectorAll(".button-block__wrap");
		
		anime({
			targets: buttons,
			opacity: [0,1],
			duration: 700,
			delay: anime.stagger(200),
			easing: "easeOutCubic"
		});
		
	}
}

export default buttonBlockAnimation;

